import Image from 'next/image'
import {
  EmailShareIcon,
  FacebookShareIcon,
  PinterestShareIcon,
} from 'primitives/icons/social-share-icons'
import { IconForwardToInbox } from '@repo/design-system-cf/components/icons'

import MessengerImg from '../assets/messenger.svg'
import TwitterImg from '../assets/x-twitter.svg'
import WhatsappImg from '../assets/whatsapp.svg'
import RedditImg from '../assets/reddit.svg'
import { CF_FACEBOOK_ID } from '../../../../config'

export interface ShareOption {
  label: string
  icon: React.ReactElement<any>
  getHref: (shareUrl: string) => string
}

export const SHARE_OPTIONS: ShareOption[] = [
  {
    label: 'Facebook',
    icon: <FacebookShareIcon className="!size-7" />,
    getHref: shareUrl => `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
  },
  {
    label: 'Messenger',
    icon: <Image src={MessengerImg} height={28} width={28} alt="Messenger" />,
    getHref: shareUrl =>
      `https://www.facebook.com/dialog/send?app_id=${CF_FACEBOOK_ID}&link=${shareUrl}&redirect_uri=${shareUrl}`,
  },
  {
    label: 'Pinterest',
    icon: <PinterestShareIcon className="!size-7" />,
    getHref: shareUrl => `https://pinterest.com/pin/create/button/?url=${shareUrl}`,
  },
  {
    label: 'Reddit',
    icon: <Image src={RedditImg} height={28} width={28} alt="Reddit" />,
    getHref: shareUrl => `https://www.reddit.com/submit?url=${shareUrl}`,
  },
  {
    label: 'X (Twitter)',
    icon: <Image src={TwitterImg} height={28} width={28} alt="Twitter" />,
    getHref: shareUrl =>
      `https://twitter.com/intent/tweet?text=CCheck%20out%20this%20on%20Creative%20Fabrica%3A%20${shareUrl}`,
  },
  {
    label: 'WhatsApp',
    icon: <Image src={WhatsappImg} height={28} width={28} alt="WhatsApp" />,
    getHref: shareUrl =>
      `https://api.whatsapp.com/send?text=Check%20out%20this%20on%20Creative%20Fabrica%3A%20${shareUrl}`,
  },
  {
    label: 'Email',
    icon: <IconForwardToInbox className="!size-7" />,
    getHref: shareUrl =>
      `mailto:?subject=Check%20out%20this%20on%20Creative%20Fabrica%3A%20&body=I%20think%20you%20would%20like%20this%20post:%20${shareUrl}`,
  },
]
